import React from "react";
import Ecosystem from "../components/sections/Ecosystem";
import { useLang } from "../i18n/LanguageContext";

const EcosystemPage = () => {
  const { t } = useLang();
  return (
    <div className="pt-28" data-testid="ecosystem-page">
      <div className="container-sat pt-8">
        <div className="overline mb-4">{t("ecosystem.overline")}</div>
        <h1 className="headline-xl text-5xl md:text-7xl">{t("ecosystem.title")}</h1>
        <p className="serif italic text-xl text-white/55 mt-6 max-w-2xl">{t("ecosystem.subtitle")}</p>
      </div>
      <Ecosystem />
    </div>
  );
};

export default EcosystemPage;
